import { IMyQuestionItem, IProjectItem } from '@/sub-luca-plugin/types';
import Http from '@/sub-luca-plugin/utils/http';
import { IPageResponse } from '@/types';

// 获取提问列表项目科目列表
export const query_projects_of_questions = (params: {
    projectId?: number;
    subjectId?: number;
    twoLevelSubjectId?: number; // 二级科目id
    channelSource?: number; // 渠道来源 高顿：100537564 上岸鸭公考：100537563
}) => Http.get<IProjectItem[]>('/athena/api/v1/front/luca-ask/project/subject/list', params);

// 获取提问列表
export const query_questions = (params: {
    resourceId?: number;
    courseId?: number;
    projectId?: number; // 项目id
    subjectId?: number; // 科目id
    twoLevelSubjectId?: number; //	二级科目id
    channelSource?: number; // 渠道来源 高顿：100537564 上岸鸭公考：100537563
    lucaId?: number; //	lucaId
    pageSize: number; // 每页数量 默认20
    pageNum: number; //	当前页码
}) => Http.get<IPageResponse<IMyQuestionItem>>('/athena/api/v1/front/luca-ask/list', params);

// 更新未读消息状态
export const read_message = (id: number) => Http.post(`/athena/api/v1/front/luca-ask/${id}/question/state`);

// 获取问题详情
export const questions_item_detail = (id: number) => Http.get(`/athena/api/v1/front/luca-ask/chat/${id}`);
